// This file is automatically generated. Do not edit it directly.
// CLIENT-SIDE ONLY Supabase client
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getClientRuntimeConfig } from '@/utils/client-runtime-config';

// Initialize only on client-side
let supabase: SupabaseClient<Database>;
let SUPABASE_URL: string = '';

if (typeof window !== 'undefined') {
  // Client-side: initialize Supabase
  const config = getClientRuntimeConfig();
  
  // Validate Supabase-specific requirements
  if (!config.SUPABASE_URL || !config.SUPABASE_ANON_KEY) {
    throw new Error('Missing required Supabase configuration');
  }
  
  SUPABASE_URL = config.SUPABASE_URL;
  
  supabase = createClient<Database>(
    config.SUPABASE_URL,
    config.SUPABASE_ANON_KEY,
    {
      auth: {
        storage: window.localStorage,
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true, // Enable automatic token detection from URL fragments
      },
      global: {
        // Set a reasonable timeout for queries
        fetch: (url: string, options: RequestInit = {}) => {
          const fetchOptions = {
            ...options,
            // Ensuring explicit timeout is set for all requests
            signal: AbortSignal.timeout(15000), // 15 seconds timeout
          };
          return fetch(url, fetchOptions);
        }
      }
    }
  );
} else {
  // Server-side: create a stub that won't crash during SSR
  // This will never actually be used, but allows imports to work
  supabase = {} as SupabaseClient<Database>;
}

// Export the initialized client and URL
export { supabase, SUPABASE_URL };